(function () {
  var SECTION_SELECTOR = '.ctr-ingredients-carousel';
  var DESKTOP_MQ = '(min-width: 750px)';

  function getSwiper() {
    return window.Swiper || null;
  }

  function destroySwiper(section) {
    if (section._ctrIcSwiper) {
      section._ctrIcSwiper.destroy(true, true);
      section._ctrIcSwiper = null;
    }
  }

  function initSwiper(section) {
    var SwiperLib = getSwiper();
    if (!SwiperLib) return;

    var el = section.querySelector('[data-ctr-ic-swiper]');
    if (!el) return;

    destroySwiper(section);

    if (!window.matchMedia(DESKTOP_MQ).matches) return;

    var paginationEl = section.querySelector('[data-ctr-ic-pagination]');
    var prevEl = section.querySelector('[data-ctr-ic-prev]');
    var nextEl = section.querySelector('[data-ctr-ic-next]');

    section._ctrIcSwiper = new SwiperLib(el, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      // centeredSlides: true,
      loop: true,
      // watchOverflow: true,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
    });
  }

  function initSection(section) {
    if (!section) return;

    initSwiper(section);

    if (section.dataset.ctrIcReady === 'true') return;
    section.dataset.ctrIcReady = 'true';

    var mq = window.matchMedia(DESKTOP_MQ);
    var onChange = function () {
      initSwiper(section);
    };

    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else if (mq.addListener) {
      mq.addListener(onChange);
    }

    section._ctrIcMqCleanup = function () {
      if (mq.removeEventListener) {
        mq.removeEventListener('change', onChange);
      } else if (mq.removeListener) {
        mq.removeListener(onChange);
      }
    };
  }

  function findSection(root) {
    if (!root) return null;
    if (root.matches && root.matches(SECTION_SELECTOR)) return root;
    return root.querySelector ? root.querySelector(SECTION_SELECTOR) : null;
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  function whenSwiperReady(cb) {
    if (getSwiper()) {
      cb();
      return;
    }

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (getSwiper() || tries > 40) {
        clearInterval(timer);
        if (getSwiper()) cb();
      }
    }, 50);
  }

  whenSwiperReady(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = findSection(event.target);
    if (!section) return;
    delete section.dataset.ctrIcReady;
    whenSwiperReady(function () {
      initSection(section);
    });
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = findSection(event.target);
    if (!section) return;
    if (section._ctrIcMqCleanup) {
      section._ctrIcMqCleanup();
      section._ctrIcMqCleanup = null;
    }
    destroySwiper(section);
    delete section.dataset.ctrIcReady;
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest
      ? event.target.closest('.ctr-ingredients-carousel__slide')
      : null;
    if (!slide) return;

    var section = slide.closest(SECTION_SELECTOR);
    if (!section || !section._ctrIcSwiper) return;

    var index = Array.prototype.indexOf.call(
      section.querySelectorAll('.ctr-ingredients-carousel__slide'),
      slide
    );
    if (index < 0) return;

    if (section._ctrIcSwiper.params.loop) {
      section._ctrIcSwiper.slideToLoop(index);
    } else {
      section._ctrIcSwiper.slideTo(index);
    }
  });
})();
